import { Observable } from 'rxjs/Observable';
import { Component, ElementRef, NgZone, OnInit, Renderer, ViewChild } from '@angular/core';
import {
  Event as RouterEvent,
  // import as RouterEvent to avoid confusion with the DOM Event
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  ActivatedRoute
} from '@angular/router';
import { AuthService } from './modules/auth/auth.service';
import { ThemeService } from './theme/theme.service';
import { filter, tap } from 'rxjs/operators';
import * as store from 'store';
import { ThemeDirective } from './theme/theme.directive';
import { app_themes } from './theme/themes.const';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLogged: Observable<boolean>;
  year = '';
  launchYear = 2017;
  appCopyright = 'The Event App';

  @ViewChild('spinner') private spinnerElement: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private ngZone: NgZone,
    private renderer: Renderer,
    private themeService: ThemeService
  ) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit(): void {
    this.isLogged = this.authService.isLoggedIn();
    this.authService.init();
    const year = new Date().getFullYear();
    this.year = this.launchYear.toString();
    if (year > this.launchYear) this.year += `-${year.toString()}`;

    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
        })
      )
      .subscribe(null);
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    let newTheme: any;
    let _copyright: any;
    if (data.theme) {
      const appTheme = app_themes[data.theme];
      if (appTheme) {
        newTheme = data.theme;
        _copyright = appTheme[ThemeDirective.COPYRIGHT];
      }
    }
    this.appCopyright = _copyright ? _copyright : this.appCopyright;
    if (newTheme) this.themeService.setActiveTheme(newTheme);
  }

  // Shows and hides the loading spinner during RouterEvent changes
  private navigationInterceptor(event: RouterEvent): void {
    const isNavigation =
      event instanceof NavigationStart ||
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError;
    if (!this.spinnerElement || !isNavigation) return;
    this.toggleSpinner(event instanceof NavigationStart);
  }
  private toggleSpinner(show: boolean): void {
    // Time-out to handle artifacts of the first frame rendering
    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        this.renderer.setElementStyle(
          this.spinnerElement.nativeElement,
          'display',
          show ? 'flex' : 'none'
        );
      });
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts